// extracted by mini-css-extract-plugin
export var centralLogoWrapper = "landing-section-module--central-logo-wrapper--rTtMD";
export var landingCarouselWrapper = "landing-section-module--landing-carousel-wrapper--vq22n";
export var leftNeonWrapper = "landing-section-module--left-neon-wrapper--o-fut";
export var rightNeonWrapper = "landing-section-module--right-neon-wrapper--HsDAV";